import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DocumentoDTO } from "app/main/apps/shared/interfaces/documento.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { PersonasService } from "app/main/apps/shared/services/rest/personas.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-certificaciones",
    templateUrl: "./certificaciones.component.html",
    styleUrls: ["./certificaciones.component.scss"],
})
export class CertificacionesComponent implements OnInit {
    @Input() rutContratista: any;
    @Input() puedeEditar:boolean;
    @Input() eliminado: boolean;
    @Output() eliminarCertificacion: EventEmitter<any> = new EventEmitter();
    @Output() agregarDocumento: EventEmitter<boolean> = new EventEmitter();

    documentos: DocumentoDTO[];

    constructor(
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _personaSrvc: PersonasService
    ) {}

    ngOnInit(): void {
        //console.log('this.rutContratista - v3');
        //console.log(this.rutContratista);

        this._personaSrvc
            .fetchDocumentos(this.rutContratista)
            .subscribe((resp) => {
                this.documentos = resp;
            });
        this._personaSrvc.documentosChanged$.subscribe((resp) => {
            this._personaSrvc
                .fetchDocumentos(this.rutContratista)
                .subscribe((resp) => {
                    this.documentos = resp;
                });
        });
    }

    verDocumento(id: number) {
        this._personaSrvc
            .fetchDocumento(id, this.rutContratista)
            .subscribe((blob) => {
                const a = document.createElement("a");
                let url = window.URL.createObjectURL(blob);
                a.target = "_blank";
                a.setAttribute("download", "Documento_" + this.rutContratista);

                a.href = url;
                a.click();
                a.remove();
            });
    }

    eliminar(certificacion) {
        this.eliminarCertificacion.emit(certificacion);
    }

    agregar() {
        this.agregarDocumento.emit(true);
    }
}
